var map = {
	"./banana_tree/UK/bt_bath/events.csv": [
		5724,
		5724
	],
	"./banana_tree/UK/bt_battersea/events.csv": [
		2874,
		2874
	],
	"./banana_tree/UK/bt_birmingham_bullring/events.csv": [
		9291,
		9291
	],
	"./banana_tree/UK/bt_cardiff/events.csv": [
		3490,
		3490
	],
	"./banana_tree/UK/bt_chelmsford/events.csv": [
		5294,
		5294
	],
	"./banana_tree/UK/bt_covent_garden/events.csv": [
		595,
		2976
	],
	"./banana_tree/UK/bt_greenwich/events.csv": [
		2519,
		2519
	],
	"./banana_tree/UK/bt_haywards_heath/events.csv": [
		6393,
		6393
	],
	"./banana_tree/UK/bt_henley/events.csv": [
		5322,
		5322
	],
	"./banana_tree/UK/bt_islington/events.csv": [
		6526,
		6526
	],
	"./banana_tree/UK/bt_maida_vale/events.csv": [
		2928,
		2928
	],
	"./banana_tree/UK/bt_milton_keynes/events.csv": [
		1436,
		1436
	],
	"./banana_tree/UK/bt_oxford/events.csv": [
		6243,
		6243
	],
	"./banana_tree/UK/bt_portsmouth/events.csv": [
		9382,
		9382
	],
	"./banana_tree/UK/bt_salford_quays/events.csv": [
		784,
		784
	],
	"./banana_tree/UK/bt_soho/events.csv": [
		5698,
		5698
	],
	"./banana_tree/UK/bt_stevenage/events.csv": [
		6265,
		6265
	],
	"./banana_tree/UK/bt_the_o2/events.csv": [
		1196,
		1196
	],
	"./banana_tree/UK/bt_west_hampstead/events.csv": [
		2248,
		2248
	],
	"./banana_tree/UK/bt_windsor/events.csv": [
		8485,
		8485
	],
	"./breakfast_club/UK/london_bridge/events.csv": [
		2252,
		2252
	],
	"./brother_marcus/UK/week1/events.csv": [
		8557,
		8557
	],
	"./brother_marcus/UK/week2/events.csv": [
		2140,
		2140
	],
	"./brother_marcus/UK/week3/events.csv": [
		6931,
		6931
	],
	"./brother_marcus_south_ken/UK/week1/events.csv": [
		1500,
		1500
	],
	"./brother_marcus_south_ken/UK/week2/events.csv": [
		8957,
		8957
	],
	"./brother_marcus_south_ken/UK/week3/events.csv": [
		2054,
		2054
	],
	"./honest_burger/UK/south_ken/events.csv": [
		8163,
		544
	],
	"./honest_burger/UK/week1/events.csv": [
		9336,
		9336
	],
	"./honest_burger/UK/week3/events.csv": [
		7378,
		7378
	],
	"./kricket/UK/shoreditch/events.csv": [
		6422,
		6422
	],
	"./moto/UK/cherwell_valley_burger_king/events.csv": [
		559,
		559
	],
	"./moto/UK/cherwell_valley_greggs/events.csv": [
		4805,
		4805
	],
	"./moto/UK/chieveley_burger_king/events.csv": [
		259,
		259
	],
	"./moto/UK/chieveley_greggs/events.csv": [
		9025,
		9025
	],
	"./moto/UK/toddington_burger_king/events.csv": [
		6515,
		6515
	],
	"./moto/UK/toddington_greggs/events.csv": [
		1201,
		1201
	],
	"./sushi_dog/UK/week1/events.csv": [
		9726,
		9726
	],
	"./sushi_dog/UK/week2/events.csv": [
		4507,
		4507
	],
	"./sushi_dog/UK/week3/events.csv": [
		6487,
		8868
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9564;
module.exports = webpackAsyncContext;